import { phoneNumberRegex } from '../constants';
import { emailRegexValidation, licenseNumberValidation, passwordValidation } from '../utils/validate';
import { isTemporaryEmail } from '../utils/checkers';
import checkIsraelCardholderId from '../utils/checkIsraelCardholderId';

export const ERRORS = {
  REQUIRED_FIELD: 'required',
  NUMBER: 'number',
  PHONE_NUMBER: 'phone-number',
  EMAIL: 'email',
  LICENSE_NUMBER: 'license-number',
  PASSWORD: 'min-length-password',
  ISRAEL_ID: 'israel-id',
  TEMP_EMAIL: 'temp-email',
  MIN_LENGTH: 'min-length',
  MAX_LENGTH: 'max-length'
};

export const minLength = (min, ending = null) => (value = '') => ((value.length < min)
  ? `${ERRORS.MIN_LENGTH}${ending ? `-${ending}` : ''}`
  : undefined
);
export const maxLength = (max, ending = null) => (value = '') => ((value.length > max)
  ? `${ERRORS.MAX_LENGTH}${ending ? `-${ending}` : ''}`
  : undefined
);

export const required = value => (!value ? ERRORS.REQUIRED_FIELD : undefined);
export const number = value => (value && Number.isNaN(Number(value)) ? ERRORS.NUMBER : undefined);
export const phoneNumber = value => (!phoneNumberRegex.test(value) ? ERRORS.PHONE_NUMBER : undefined);
export const email = value => (!emailRegexValidation(value) ? ERRORS.EMAIL : undefined);
export const notRequiredEmail = value => (value && !emailRegexValidation(value) ? ERRORS.EMAIL : undefined);
export const noTempMail = value => (value && isTemporaryEmail(value) ? ERRORS.TEMP_EMAIL : undefined);
export const licenseNumber = value => (!licenseNumberValidation(value) ? ERRORS.LICENSE_NUMBER : undefined);
export const israelCardholderId = value => (!checkIsraelCardholderId(value) ? ERRORS.ISRAEL_ID : undefined);
export const passwordLength = password => (!passwordValidation(password) ? ERRORS.PASSWORD : undefined);
